export default "__VITE_ASSET__BLdS9dmd__"